import Main from 'import'
new Main



// WEBPACK FOOTER //
// ./webpack/src/wp/wp-content/themes/skyrent2018/scripts/bundle.coffee